"use client";

import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight } from "lucide-react";
import Link from "next/link";

interface ConversionData {
  ctaText: string;
  ctaUrl: string;
}

export default function ConversionBanner() {
  const [data, setData] = useState<ConversionData | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetch("/api/settings/public")
      .then((res) => res.json())
      .then((settings) => {
        if (settings.conversionModeSite || settings.conversionModePlatforma) {
          setData({
            ctaText: settings.conversionCtaText,
            ctaUrl: settings.conversionCtaUrl,
          });
        }
      })
      .catch(() => {});
  }, []);

  // Zawsze renderujemy AnimatePresence ze stabilnym kszta\u0142tem drzewa.
  // Warunki przeniesione do \u015brodka, \u017ceby unikn\u0105\u0107 mountowania/odmount-owania
  // tego komponentu po hydratacji (psuje reconcilera = "removeChild parentNode null"
  // i wymusza podw\u00f3jne klikni\u0119cia w nawigacji App Routera).
  const visible = !!data && !dismissed;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="conversion-banner"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-primary via-blue-500 to-indigo-600 text-white py-2.5 px-4"
        >
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 text-sm">
            <span className="font-medium">
              🔥 Oferta specjalna — nie przegap!
            </span>
            <Link
              href={data!.ctaUrl}
              className="inline-flex items-center gap-1.5 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full font-semibold transition-colors"
            >
              {data!.ctaText}
              <ArrowRight className="w-3.5 h-3.5" />
            </Link>
            <button
              onClick={() => setDismissed(true)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
